import { defineStore } from 'pinia'
import { ref, reactive } from 'vue'
import VueCookies from 'vue-cookies'
import { setToken } from '../api'

import { signIn } from '../api/auth'
import { ACCESS_TOKEN } from '../constants'

import type { ErrorType } from '../types/base'
import type { DataAuthType } from '../types/auth'

export const useAuthStore = defineStore('auth', () => {
  const token = ref('')
  const error = reactive<ErrorType>({
    isError: false,
    text: '',
  })

  const getToken = async (payload: DataAuthType) => {
    try {
      error.isError = false

      const { data } = await signIn(payload)
      token.value = data.token
      VueCookies.set(ACCESS_TOKEN, data.token)
      setToken(data.token)
      return data
    } catch (err: unknown) {
      const e = err as any
      const apiMessage = e?.response?.data?.errors?.[0]?.message || e?.message || 'Login failed'
      error.isError = true
      error.text = apiMessage
      throw new Error(apiMessage)
    }
  }

  const signOut = () => {
    VueCookies.remove(ACCESS_TOKEN)
  }

  const initialize = (): boolean => {
    const accessToken = VueCookies.get(ACCESS_TOKEN)
    if (!accessToken) return false
    setToken(accessToken)
    token.value = accessToken
    return true
  }

  return {
    error,
    token,
    signOut,
    getToken,
    initialize,
  }
})
